// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-ztzvt{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-info-__slug-indexstyleGrid-grid-muwlj{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-boxkt{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-jfuyf{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-bvaot{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-bmfup{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-bzsco{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-glofd{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-ztzvt",
	"grid": "pages-info-__slug-indexstyleGrid-grid-muwlj",
	"col6": "pages-info-__slug-indexstyleGrid-col6-boxkt",
	"col3": "pages-info-__slug-indexstyleGrid-col3-jfuyf",
	"col4": "pages-info-__slug-indexstyleGrid-col4-bvaot",
	"col9": "pages-info-__slug-indexstyleGrid-col9-bmfup",
	"col12": "pages-info-__slug-indexstyleGrid-col12-bzsco",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-glofd"
};
module.exports = ___CSS_LOADER_EXPORT___;
